const FeedSourceType = {
	FEED: 'feed',
	TEAM_FEED: 'team_feed',
	POPULAR: 'popular',
	SEARCH: 'search',
	BOARD: 'board',
	RELATED: 'related',
	USER: 'user',
	LIST: 'list',
} as const;

export default FeedSourceType;
